<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="conscent ? handleContinue() : (beforeWeBegin = true)"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.codigo }} - {{ $t('descricao') }} : {{ item.descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<div class="container__crudactions__cruddownload__download">
					<!-- <DownloadButton /> -->
				</div>
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVBaseHistorica()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:backdrop="true"
		>
			<template #stepper>
				<div class="pl-9 pt-9">
					<RadialStepper
						v-model="step"
						:steps="steps"
					/>
				</div>
			</template>

			<template #form>
				<div class="px-9 pt-9">
					<div class="mb-6">
						<h1 class="font-bold text-2xl text-[#272728]">
							{{ isEdit ? $t('editHistoricalBase') : $t('createHistoricalBase') }}
						</h1>
						<p class="text-base text-[#272728] !m-0">
							{{ $t('instructionHistoricalBase') }}
						</p>
						<a
							@click="
								beforeWeBegin = true
								showForm = false
							"
							>{{ $t('verInstrucoes') }}</a
						>
					</div>
					<div class="flex flex-col gap-4">
						<InputText
							v-model="descricao"
							:label="$t('description')"
						>
							<Tooltip
								:titulo="$t('description')"
								:conteudo="$t('tooltipDescription')"
							/>
						</InputText>
						<NewUploadFile
							v-if="!isEdit"
							:files="$store.state.moduleDadosHistoricos.file"
							@onInput="$store.dispatch('moduleDadosHistoricos/handleFileUpload', $event)"
						/>
					</div>
					<div class="flex gap-4 mt-8">
						<Button
							:label="$t('cancel').toLowerCase()"
							color="trv-primary"
							outlined
							@click="showForm = false"
						/>
						<Button
							v-if="!isEdit"
							:label="$t('validateBase').toLowerCase()"
							:disabled="
								!$store.state.moduleDadosHistoricos.descricao ||
								!$store.state.moduleDadosHistoricos.file?.length
							"
							@click="$router.push('/baseHistorica/validarBase')"
						/>
						<Button
							v-else
							:label="$t('save')"
							:loading="loadingUpdate"
							@click="updateBase"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
		<InstrucaoBaseHistorica
			v-if="beforeWeBegin"
			chave="historica"
			:colunas="$store.getters['moduleDadosHistoricos/colunasMapeamento']"
			:colunas-processamento="$store.getters['moduleDadosHistoricos/colunasProcessamento']"
			@continue="handleContinue"
			@previous="handlePrevious"
		/>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import InstrucaoBaseHistorica from '../../../components/InstrucaoBaseHistorica/InstrucaoBaseHistorica.vue'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import NewUploadFile from '../../../components/NewFileUpload/NewFileUpload.vue'
import Pagination from '../../../components/Pagination/Pagination'
import RadialStepper from '../../../components/RadialStepper/RadialStepper.vue'
import Tooltip from '../../../components/Tooltip/Tooltip.vue'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	deleteBaseHistoricaByIdList,
	getAllDadosHistoricos,
	updateBaseHistorica,
} from '../../../services/requests/DadosHistoricosRequests'

import { useLocalStorage } from '@vueuse/core'

import { exportarCsv } from '../../../utils/csvHellpers'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Button,
		CrudForm,
		CrudTable,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		KebabMenu,
		RadialStepper,
		NewUploadFile,
		InstrucaoBaseHistorica,
		Tooltip,
		ExclusionAlert,
	},
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			beforeWeBegin: false,
			step: 1,
			steps: [],
			showExclusionAlert: false,
			intention: {},
			headersSelecionados: ['descricao', 'codigo', 'periodo', 'parcelas'],
			tableHeaders: [
				{ key: 'codigo', value: this.$t('code'), isActive: true },
				{ key: 'descricao', value: this.$t('description'), isActive: true },
				{
					key: 'periodo',
					value: this.$t('period'),
					isActive: true,
				},
				{
					key: 'parcelas',
					value: this.$t('plots'),
					isActive: true,
				},
			],

			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				descricao: '',
			},
			file: [],
			loadingUpdate: false,
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'PROG',
				subtitleCardPropertie: 'descricao',
				titleCardPropertie: 'codigo',
			},
		}
	},
	computed: {
		conscent() {
			return JSON.parse(useLocalStorage('conscent-historica', false).value)
		},
		descricao: {
			get() {
				return this.$store.state.moduleDadosHistoricos.descricao
			},
			set(value) {
				this.$store.commit('moduleDadosHistoricos/setDescricao', value)
			},
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
				{
					value: 'visualizar',
					label: this.$t('toView'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.descricao
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
				case 'visualizar':
					this.$router.push({ path: '/baseHistorica/visualizarDispersao', query: { id: model.id } })
					break
			}
		},
	},
	created() {
		this.model.variaveisBiometricas = this.variaveisBiometricas
		this.quantityPerPage = 10
		this.steps = [
			{ name: this.$t('cadastrarBaseHistorica'), step: 1 },
			{ name: this.$t('validarBaseImportada'), step: 2 },
			{ name: this.$t('visualizeDispersion'), step: 3 },
		]
		// this.orderTable = ["prog_dt_data"];
		getAllDadosHistoricos().then(async (response) => {
			var { data: dadosHistoricos } = response

			// dadosHistoricos.forEach((dadoHistorico) => this.formataDadoHistoricoParaTabela(dadoHistorico));
			this.modelList = dadosHistoricos
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		this.$store.commit('moduleDadosHistoricos/setDescricao', undefined)
		this.$store.commit('moduleDadosHistoricos/setUploadedFile', undefined)
		this.$store.commit('moduleDadosHistoricos/setMedicoesHistoricas', [])
	},

	/**
	 * Configura para exibir o Model de Cadastro
	 */

	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		updateBase() {
			this.loadingUpdate = true
			updateBaseHistorica({
				...this.model,
				descricao: this.$store.state.moduleDadosHistoricos.descricao,
			}).then(() => {
				this.loadingUpdate = false
				this.showForm = false
				window.location.reload()
			})
		},
		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},
		handleContinue() {
			this.showNewModelForm()
			this.beforeWeBegin = false
		},
		handlePrevious() {
			this.beforeWeBegin = false
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			this.$store.commit('moduleDadosHistoricos/setDescricao', this.model.descricao)

			this.titleForm = `${this.$t('edit')} ${this.$t('historicalBase')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},
		/**
		 * Exclui estrato inventario cubagem no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const confirmResult = confirm('Deseja realmente excluir esses registros?')

				if (confirmResult) {
					deleteBaseHistoricaByIdList(this.modelsIdWithCheckedToDelete)
						.then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
						.catch((error) => {
							this.mutationShowMessage({
								messageTitle: 'Atenção!',
								messageIcon: 'far fa-times-circle',
								messageType: 'error',
								messageText: error.response.data.errors.Mensagens[0],
							})
						})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.model.id = uuidv4()
			this.titleForm = `${this.$t('create')} ${this.$t('prognosis')}`
			this.isEdit = false
			this.variaveisEscolhidas = this.variaveisBiometricas
			this.changeFormAndCloseAllActions()
			console.log(this.model)
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataPrognoseParaTabela(prognose) {
			prognose.isCheckedToDelete = false
			prognose.dataDaPrognose = prognose.dataDaPrognose
				? new Date(prognose.dataDaPrognose).toLocaleDateString()
				: ''
		},

		/**
		 * Base historica
		 */
		downloadCSVBaseHistorica() {
			let cabecalhoDoCsvDadosHistoricos = ['Código', 'Descrição', 'Período', 'Parcelas']
			const items = this.modelList

			const linhas = items.map((item) => [item.codigo, item.descricao, item.periodo, item.parcelas])

			exportarCsv('export_base_historica', cabecalhoDoCsvDadosHistoricos, linhas)
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>

<style scoped>
#dropdown_variaveis_biometricas {
	margin-top: 1rem;
}
</style>
